import { c as _c } from "react/compiler-runtime";
import { Disclosure } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import Image from 'next/image';
import { useRef, useState } from 'react';
import { useEffectOnce } from 'react-use';
import type { IBullet } from '../home.interface';
import type { IProps } from './FeaturesPage';

/* Feature with Expandable bullets */
export const DataTypeFeature = t0 => {
  const $ = _c(17);
  const {
    feature
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      container: {
        background: "linear-gradient(180deg, rgba(242, 250, 255, 0) 0%, #F2FAFF 55.21%, rgba(242, 250, 255, 0) 100%)"
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const styles = t1;
  const [clicked, setClicked] = useState(0);
  const buttonRefs = useRef([]);
  const openedRef = useRef(null);
  const clickRecent = index => {
    const clickedBtn = buttonRefs.current[index];
    if (clickedBtn === openedRef.current) {
      openedRef.current = null;
      return;
    }
    if (openedRef.current?.getAttribute("data-value")) {
      openedRef.current?.click();
    }
    openedRef.current = clickedBtn;
  };
  useEffectOnce(() => {
    openedRef.current = buttonRefs.current[0];
  });
  const defaultImage = `/images/icons/datatype/datatype-${clicked + 1}/datatype_${clicked + 1}-1x.png`;
  const t2 = "container mx-auto flex flex-col p-4 md:flex-row md:items-center md:justify-center md:gap-x-[10%] md:px-[10%]";
  const t3 = feature.bullets?.[clicked] ? feature.bullets[clicked].alt : "image";
  let t4;
  if ($[1] !== defaultImage || $[2] !== t3) {
    t4 = <div className="w-full md:w-[50%] "><Image src={defaultImage} width={1024} height={1024} alt={t3} /></div>;
    $[1] = defaultImage;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = "flex flex-col md:max-w-[40%]";
  let t6;
  if ($[4] !== feature.title) {
    t6 = <div className="mb-3 text-xl font-medium text-[#3D3E40] md:text-2xl lg:text-4xl">{feature.title}</div>;
    $[4] = feature.title;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== feature.description) {
    t7 = <div className="mb-5 py-2 text-[15px] font-normal text-[#616366]">{feature.description}</div>;
    $[6] = feature.description;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = "flex flex-col";
  const t9 = "grid grid-cols-1 divide-y";
  const t10 = feature.bullets?.map((bullet, idx) => <div key={idx} className="mx-auto w-full opacity-75 hover:bg-gray-100 focus:outline-none focus-visible:ring focus-visible:ring-sky-500"><Disclosure defaultOpen={idx === clicked}>{t11 => {
        const {
          open
        } = t11;
        return <><Disclosure.Button ref={ref => {
            buttonRefs.current[idx] = ref;
          }} className="flex w-full justify-between py-5 text-left" onClick={() => {
            if (!open) {
              setClicked(idx);
            }
            clickRecent(idx);
          }} data-value={open}><span className="text-[17px] font-medium text-[#555659]">{bullet.title}</span><div className="h-5 w-5 shrink-0 grow-0"><ChevronDownIcon className={`mt-1 text-gray-900 ${open ? "rotate-180" : ""}`} /></div></Disclosure.Button><Disclosure.Panel className="pb-4 pt-2 text-sm text-gray-700"><div className="text-left text-[16px] font-normal text-[#616366]">{bullet.details}</div></Disclosure.Panel></>;
      }}</Disclosure></div>);
  let t12;
  if ($[8] !== t10) {
    t12 = <div className={t8}><div className={t9}>{t10}</div></div>;
    $[8] = t10;
    $[9] = t12;
  } else {
    t12 = $[9];
  }
  let t13;
  if ($[10] !== t12 || $[11] !== t6 || $[12] !== t7) {
    t13 = <div className={t5}>{t6}{t7}{t12}</div>;
    $[10] = t12;
    $[11] = t6;
    $[12] = t7;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] !== t13 || $[15] !== t4) {
    t14 = <div style={styles.container}><div className={t2}>{t4}{t13}</div></div>;
    $[14] = t13;
    $[15] = t4;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  return t14;
};